var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ei-works-list',{attrs:{"works-list":_vm.worksPage.list}}),_c('ei-pages',{attrs:{"total":_vm.worksPage.total,"page-num":_vm.worksPage.pageNum,"page-size":_vm.worksPage.pageSize},on:{"pageNumChange":_vm.pageNumChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }